import { createContext, useContext } from "react"

import { SidePanelContentContextValues } from "./SidePanelContent.types"

export const SidePanelContentContext = createContext<SidePanelContentContextValues | undefined>(undefined)
SidePanelContentContext.displayName = "SidePanelContentContext"

export function useSidePanelContent(): SidePanelContentContextValues {
    const context = useContext(SidePanelContentContext)
    if (!context) {
        throw new Error("useSidePanelContent must be used within a SidePanelContent component")
    }
    return context
}
